import type { InternalAxiosRequestConfig } from 'axios';
import type { AuthProvider, AuthType } from './AuthProvider';

export class CookieAuthProvider implements AuthProvider {
  readonly authType: AuthType = 'cookie';

  applyTo(request: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
    request.withCredentials = true;
    return request;
  }
}
